import React from 'react'
import logo from '../images/logoPrikazka.png'
import { BsInfoSquare } from 'react-icons/bs'
import {MdOutlineLanguage} from 'react-icons/md'
import { BsFiletypePdf } from "react-icons/bs";

const Header = ({info, isEng, setIsEng, showAllergens,handlePdfOpen, handleShowInfoClick, handleShowAllergensClick, pdfMenuState}) => {
   
    let objectVariation = info[0].variation
    let objectVariationEng = info[0].variation_eng
   
    return (
        <header className="w-full flex h-14 bg-[backgroundOne] border-b-2 border-b-mainOne justify-center" >
            <div className="w-full max-h-full p-l-1 p-b-1 flex  justify-between ml-2">
                <div className='flex justify-start font-categories'>
                    <div>
                        { <img className='w-[160px] absolute ml-0 top-1 object-cover block -z-1000'  src={logo}/> }
                    </div>
                    <div className='text-mainThree font-bold   ml-5 p-1 flex flex-row items-center'>
                    {/* <div className='-mt-7 '>
                            <p className=' text-mainThree italic text-lg font-restaurant-type'> {objectVariation} </p>
                    </div>
                        <h1 className=' -ml-10 pt-5 great-vibes-regular text-3xl text-mainTwo'>Приказка</h1>                     
                        */}

                    </div>
                </div>
                <div className='flex font-categories justify-center items-center mr-3'>
                   
                    {/* PDF MENU */}
                    {pdfMenuState && <BsFiletypePdf  className='text-mainTwo cursor-pointer z-10 mr-3' size={35}
                        onClick={()=>{ handlePdfOpen()}}
                    />}
                    <BsInfoSquare 
                        onClick={() => handleShowInfoClick()}
                    className='text-mainTwo cursor-pointer z-10' size={35} />
                  
                    {/* <div className='ml-4 text-2xl cursor-pointer'>
                            <h1>Eng</h1>
                    </div> */}
                </div>
            </div>


        </header>
    )
}

export default Header